import { ReactNode } from "react";
import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { getOfferDisclaimer } from "src/store/selectors/vehicles";
import PaymentDisclaimer from "./PaymentDisclaimer";

function mapStateToProps(
    state: ApplicationStore,
    props: { vin: string; additionalDisclaimer?: ReactNode; offerIndex?: number }
) {
    return {
        additionalDisclaimer: props.additionalDisclaimer,
        defaultDisclaimer: getOfferDisclaimer(state, props.vin, props.offerIndex),
    };
}

export default connect(mapStateToProps)(PaymentDisclaimer);
